export default "__VITE_ASSET__fYszX_kf__"